module.exports = __webpack_public_path__ + "static/media/NOTICIAS-black.86ccfddf.png";